const numberToMonth = ({ number }) => {
  let month;
  switch (number) {
    case 1:
      month = 'Janeiro';
      break;
    case 2:
      month = 'Fevereiro';
      break;
    case 3:
      month = 'Março';
      break;
    case 4:
      month = 'Abril';
      break;
    case 5:
      month = 'Maio';
      break;
    case 6:
      month = 'Junho';
      break;
    case 7:
      month = 'Julho';
      break;
    case 8:
      month = 'Agosto';
      break;
    case 9:
      month = 'Setembro';
      break;
    case 10:
      month = 'Outubro';
      break;
    case 11:
      month = 'Novembro';
      break;
    case 12:
      month = 'Dezembro';
      break;
    default:
      throw new Error('Invalid month number.');
  }

  return month;
};

const monthToNumber = ({ month }) => {
  let number;
  switch (month) {
    case 'Janeiro':
      number = 1;
      break;
    case 'Fevereiro':
      number = 2;
      break;
    case 'Março':
      number = 3;
      break;
    case 'Abril':
      number = 4;
      break;
    case 'Maio':
      number = 5;
      break;
    case 'Junho':
      number = 6;
      break;
    case 'Julho':
      number = 7;
      break;
    case 'Agosto':
      number = 8;
      break;
    case 'Setembro':
      number = 9;
      break;
    case 'Outubro':
      number = 10;
      break;
    case 'Novembro':
      number = 11;
      break;
    case 'Dezembro':
      number = 12;
      break;
    default:
      throw new Error('Invalid month.');
  }

  return number;
};

export default {
  numberToMonth,
  monthToNumber,
};
